import React from 'react'
import AltTextInput from '../AltTextInput'
import FilePreview from '../FilePreview'
import { useTranslation } from '../../../../lib/i18n'

const ImagePreview = ({ image, setValue, setImage, register, getValues }) => {
  const { t } = useTranslation()

  return (
    <>
      <FilePreview
        preview={image.preview || image}
        filename={image?.raw?.name || t('common.image')}
        type="image"
        onClick={() => {
          if (setValue) {
            setValue('altText', null, { shouldValidate: true })
          }
          setImage(null)
        }}
      />
      <AltTextInput
        register={register}
        showText={() => {
          if (getValues) {
            return getValues('altText')
          }
          return false
        }}
      />
    </>
  )
}

export default ImagePreview
